import { Component, Input, OnChanges } from '@angular/core';

import { forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export const DOCUMENT_EDITOR_TOOLBAR_BUTTONS = ['bold', 'italic', 'underline'];

@Component({
    selector: 'app-froala-editor',
    templateUrl: './froala-editor.component.html',
    styleUrls: ['./froala-editor.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FroalaEditorComponent),
            multi: true,
        },
    ],
    standalone: false
})
export class FroalaEditorComponent implements ControlValueAccessor, OnChanges {
  @Input() readonly = false;
  @Input() toolbarButtons: string[] = [];

  value = '';
  disabled = false;

  froalaOptions: Record<string, any> = {
    key: 'ZOD3gC7A7D6E6B2B2E2C-7SLJCKHXOSLMc2YGSGe1ZXHSa1CgC3E3G3G3B7A4E3F4C2A2==',
    language: 'fr',
    attribution: false,
    fontFamilyDefaultSelection: 'Arial',
    htmlUntouched: false,
    keepFormatOnEnter: true,
    iframe: true,
    toolbarInline: false,
    toolbarSticky: false,
    quickInsertEnabled: false,
    htmlAllowedTags: ['.*', 'style'],
    htmlAllowedAttrs: ['.*'],
    htmlAllowedStyleProps: ['.*'],
    pasteDeniedAttrs: ['dir', 'role', 'aria-level'],
    htmlRemoveTags: ['wbr'],
    wordDeniedAttrs: ['dir', 'role', 'aria-level'],
    iframeDefaultStyle:
      ".page-breaker{position:relative;height:15px;padding:10px;border:2px dashed #666;margin:20px 0;text-align:center}.page-breaker::after{content:'Saut de page';position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);background:#fff;padding:0 8px;color:#666;font-size:13px;font-style:italic}",
  };

  computedOptions: Record<string, any> = this.buildOptions();

  ngOnChanges(): void {
    this.computedOptions = this.buildOptions();
  }

  private buildOptions(): Record<string, any> {
    const options = {
      ...this.froalaOptions,
      toolbarButtons: this.toolbarButtons,
      toolbarButtonsXS: this.toolbarButtons,
      toolbarButtonsSM: this.toolbarButtons,
      toolbarButtonsMD: this.toolbarButtons,
    };
    if (!this.readonly) return options;
    return {
      ...options,
      events: {
        initialized: function () {
          this.edit.off();
        },
      },
    };
  }

  onChange: (value: string) => void = () => {};
  onTouched: () => void = () => {};

  writeValue(value: string): void {
    this.value = value || '';
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onContentChanged(newValue: string) {
    this.value = newValue;
    this.onChange(this.value);
    this.onTouched();
  }
}
